import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export function BeforeAfterSlider({ before, after, label, cat, testid }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const move = (clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  return (
    <figure data-testid={testid} className="group">
      <div
        ref={ref}
        onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); move(e.clientX); }}
        onPointerMove={(e) => { if (e.buttons === 1) move(e.clientX); }}
        className="relative aspect-[4/3] overflow-hidden rounded-xl select-none touch-none cursor-ew-resize bg-surface"
      >
        <img src={after} alt={`${label} — dopo`} draggable={false} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={before} alt={`${label} — prima`} draggable={false} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        </div>

        <span className="absolute top-3 left-3 rounded-full bg-navy/80 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-white backdrop-blur-sm">Prima</span>
        <span className="absolute top-3 right-3 rounded-full bg-brand-orange px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">Dopo</span>

        <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
          <div className="absolute inset-y-0 -ml-px w-0.5 bg-white shadow-[0_0_10px_rgba(0,0,0,0.3)]" />
          <div className="absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white shadow-lg flex items-center justify-center text-navy">
            <ChevronsLeftRight size={18} />
          </div>
        </div>
      </div>
      {(label || cat) && (
        <figcaption className="mt-3">
          {cat && <span className="text-xs font-semibold uppercase tracking-wider text-brand-orange">{cat}</span>}
          {label && <p className="text-sm font-medium text-navy">{label}</p>}
        </figcaption>
      )}
    </figure>
  );
}
